export default "__VITE_ASSET__Cfw2cHRq__"